import api from "../lib/api";

export type ProfileDetailsResponse = any;

export type OrganizationDetails = {
  company_name: string | null;
  entity_type: string | null;
  organization_number: string | null;
  organization_type: string | null;
  sector: string | null;
  region: string | null;
  address_line: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  size: string | null;
  founded_year: number | null;
  website_url: string | null;
  profile_photo?: string | null;
  extra_details?: Record<string, any> | null;
  Number_of_Board_Members?: number | null;
  Number_of_Employee?: number | null;
  Number_of_Volunteers?: number | null;
  contact_email?: string | null;
  contact_phone_number?: string | null;
  phone_code?: string | null;
   age?: number|null;
  gender?: string;
  ethnicity?: string;
  disability_status?: string;
  veteran?: string;
  immigration_status?: string;
  socioeconomic_status?: string;
  rural_urban?: string;
  operating_area?: string;
};
export interface MetaOption{
  value:string;
  label:string;
}

export interface Individual {
  fields: {
    gender: MetaOption[]
    disability_status: MetaOption[]
    veteran: MetaOption[];
    immigration_status: string[];
    ethnicity: string[];
    socioeconomic_status: string[];
  };
}
export interface Geographic {
    rural_urban: string[];
    operating_area: string[]
}

export type SocialMedia = {
  twitter?: string | null;
  linkedin?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  [k: string]: string | null | undefined; 
};

export type SocialProfileResponse = {
  social_media: SocialMedia | null;
};

export type SocialProfileRequest = {
  social_media: SocialMedia;
};
export type FilesAuditDoc={
  file:string;
  file_type:string;
  id:number|null; 
  uploaded_at:string;
}

export type AuditDocument={
  id: number|null;
  name:string;
  files:FilesAuditDoc[];
  created_at:string;
  expiry_date:string;
}
export const getProfileDetails = async () => {
  const { data } = await api.get<OrganizationDetails>("/users/profile/details");
  return data;
};

export const putProfileDetails = async (payload: OrganizationDetails) => {
  const { data } = await api.put<OrganizationDetails>("/users/profile/details/", payload);
  return data;
};

export const patchProfileDetails = async (body: Partial<OrganizationDetails>) => {
  const { data } = await api.patch<OrganizationDetails>("/users/profile/details/", body);
  return data;
};

export type UploadResponse = { url: string; file_type: string; message: string };

export const uploadProfileFile = async (
  file: File,
  file_type: "profile_photo" | "audit_statement" | "team_member_avatar" = "profile_photo",
  team_member_id?: number
) => {
  const form = new FormData();
  form.append("file", file);
  form.append("file_type", file_type);
  if (typeof team_member_id === "number") form.append("team_member_id", String(team_member_id));
  const { data } = await api.post<UploadResponse>("/users/profile/uploads/", form, {
    headers: { "Content-Type": "multipart/form-data" },
  }); 
  return data;
};

export const uploadProfileDocument = async (
  file: File,
  name: string,
  expiry_date: string
) => {
  const form = new FormData();
  form.append("file", file);
  form.append("name", name);
  form.append("expiry_date", expiry_date);

  const { data } = await api.post("/users/profile/documents/upload/", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  // console.log(data);
  
  return data;
};

export const getUploadProfileDocument=async()=>{
  const {data}= await api.get("/users/profile/documents/")
  // console.log(data);
  
  return data;
}
export const getMetaIndividual=async()=>{
  const {data}= await api.get("/users/meta/individual/")
  // console.log(data);
  
  return data;
}
export const getMetaGeographic=async()=>{
  const {data}= await api.get("/users/meta/geographic/")
  // console.log(data);
  
  return data;
}


export type ProfileObjectiveResponse = {
  equality_inclusion_approach: string;
  safeguarding_approach: string;
  long_term_impact: string;
  data_collection_methods: string[];
  success_indicators: string;
  outcome_timescale: any;
  beneficiary_selection_method: string;
  beneficiaries_number: any;
  beneficiaries_description: string;
  evidence_of_need: string;
  who_is_affected: string;
  problem_statement: string;
  org_activities_summary: string;
  objective: Record<string, any> | string | null;
  project_description: string | null;
  bio: string | null;
  sector?: string | null;
};

export type ProfileObjectiveRequest = {
  objective: {
    area_focus: string;
    beneficiary_groups: string;
    sustainable_development_goal: string;
    mission: string;
    objective: string;
    organisation_history: string;
  };
  project_description: string;
  bio: string;
  sector: string;
};
export type OrganizationStats = {
  extra_details: any;
  Number_of_Board_Members: number | null; 
  Number_of_Employee: number | null;
  Number_of_Volunteers: number | null;
  // organization_type: string | null;
  // size: string | null; 
};
export type TeamMember = {
  id?: number | string;
  name: string;
  role?: string | null;
  email?: string | null;
  phone?: string | null;
  linkedin?: string | null;
  avatar?: string | null;
  created_at?: string;
  updated_at?: string;
};
export const getProfileObjective = async () => {
  const { data } = await api.get<ProfileObjectiveResponse>("/users/profile/objective");
  return data;
};

export const putProfileObjective = async (payload: ProfileObjectiveRequest) => {
  const { data } = await api.put<ProfileObjectiveResponse>("/users/profile/objective/", payload);
  return data;
};


export const getOrganizationStats = async () => {
  const { data } = await api.get<OrganizationStats>("/users/profile/organization-stats/");
  return data;
};

export const putOrganizationStats = async (payload: OrganizationStats) => {
  const { data } = await api.put<OrganizationStats>("/users/profile/organization-stats/", payload);
  return data;
};

export const getTeamMembers = async () => {
  const { data } = await api.get<TeamMember[] | { results: TeamMember[] }>(
    "/users/profile/team/members/"
  );
  return Array.isArray(data) ? data : Array.isArray((data as any)?.results) ? (data as any).results : [];
};

export const postTeamMember = async (payload: Omit<TeamMember, "id">) => {
  const { data } = await api.post<TeamMember>("/users/profile/team/members/", payload);
  return data;
};
// GET one member
export const getTeamMember = async (id: number | string) => {
  const { data } = await api.get<TeamMember>(`/users/profile/team/members/${id}/`);
  return data;
};
export const getGrantWriterDetails = async () => {
  const { data } = await api.get(`users/meta/grantwriter-meta`);
  return data;
};

// PUT update one member
export const putTeamMember = async (
  id: number | string,
  payload: { name: string; email?: string | null; linkedin?: string | null, role?: string | null }
) => {
  const body: Record<string, any> = { name: payload.name };
  if (payload.email !== undefined) body.email = payload.email;
  if (payload.linkedin !== undefined) body.linkedin = payload.linkedin;
  if (payload.role !== undefined) body.role = payload.role;

  const { data } = await api.put<TeamMember>(`/users/profile/team/members/${id}/`, body);
  return data;
};

// DELETE one member
export const deleteTeamMember = async (id: number | string) => {
  await api.delete(`/users/profile/team/members/${id}/`);
};
export const deleteFileDocumentUpload= async(id: number| null)=>{
  const {data}= await api.delete(`users/documents/files/${id}/delete/`)
  return data; 
}
export const deleteAccountForNow= async()=>{
  const {data}= await api.delete(`users/profile/delete-account/`)
  return data; 
}
export const deleteLogo=async()=>{
  const body: Record<string,any>={file_type:"profile_photo"}
  const {data}=await api.delete(`users/profile_photo/uploads/Delete/`,{data:body} )
  return data;
}

export interface FundingProfile {
  funding_goal?: string;
  funding_range?: { range?: string; label?: string; } | string;
  previous_funding?: any[];
  past_funding_sources?: string[];
  audit_statement?: string | null;
  funding_types?: string[];
  allowable_expenses?: string[];
  perferred_funder_types?: string[];
  funding_start_date?: string | null;
  deadline_preferences?: string[];
  target_application_windows?: {
    start?: string;
    end?: string;
  };
  min_funding_amount_required?: number;
  max_funding_aount_required?: number | null;
  funding_extra_details?: {
    notes?: string;
    tax_status?: string;
    years_operating?: string;
    annual_turnover_band?: string;
    matching_funds?: string;
    application_requirements?: string[];
    keywords?: string;
    seeking_investment?: string;
    investment_amount?: string | null;
    onboarding_funding_amount_band?: string;
    onboarding_funding_types?: string[];
    funding_timeline?: string;
  };
}
export const getProfileFunding = async () => {
  const { data } = await api.get<FundingProfile>("/users/profile/funding/");
  return data;
};

export const putProfileFunding = async (payload: FundingProfile) => {
  const { data } = await api.put<FundingProfile>("/users/profile/funding/", payload);
  return data;
};

// --- Social profile calls ---
export const getProfileSocial = async () => {
  const { data } = await api.get<SocialProfileResponse>("/users/profile/social/");
  return data;
};

export const putProfileSocial = async (payload: SocialProfileRequest) => {
  const { data } = await api.put<SocialProfileResponse>("/users/profile/social/", payload);
  return data;
};

export const patchProfileSocial = async (payload: Partial<SocialProfileRequest>) => {
  const { data } = await api.patch<SocialProfileResponse>("/users/profile/social/", payload);
  return data;
};

export type AIGeminiAutofillResponse = {
  message: string;
  ai_profile_id: number;
  data?: Record<string, any>;
};

export const postAIGeminiAutofill = async (
  file: File,
  extraDetails?: Record<string, any>,
  onUploadProgress?: (percent: number) => void
) => {
  const form = new FormData();
  form.append("file", file);
  if (extraDetails && Object.keys(extraDetails).length > 0) {
    form.append("extra_details", JSON.stringify(extraDetails));
  }

  const { data } = await api.post<AIGeminiAutofillResponse>(
    "/users/profile/ai-gemini-autofill/",
    form,
    {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event) => {
        if (!onUploadProgress) return;
        const total = event.total ?? (event as any).target?.getResponseHeader?.("content-length");
        if (total) {
          const percent = Math.min(100, Math.round((event.loaded / total) * 100));
          onUploadProgress(percent);
        } else if (event.loaded) {
          // Fallback when total size is not known
          onUploadProgress(50);
        }
      },
    }
  );
  return data;
};

export const applyAIProfile = async (profileId: number) => {
  const { data } = await api.post<{ message: string }>(
    `/users/apply-ai-profile/${profileId}/`,
    {}
  );
  return data;
};
